export default "__VITE_ASSET__b7dfed9a__"